import { render } from "./PainPointsSection.vue?vue&type=template&id=60fbe252&scoped=true"
import script from "./PainPointsSection.vue?vue&type=script&lang=js"
export * from "./PainPointsSection.vue?vue&type=script&lang=js"

import "./PainPointsSection.vue?vue&type=style&index=0&id=60fbe252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fbe252"]])

export default __exports__